export const omitName = (name: string, length: number): string => {
  return name.length > length ? `${name.slice(0, length)}…` : name
}
